// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qyWH","content":"styles_content__lV8si"};